module.exports = __webpack_public_path__ + "static/media/google_logo_icon.b84b0cb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google_logo_icon.svg
// module id = 65
// module chunks = 0